import { PressableIcon } from '@betty/moonlight';
import { ParamListBase } from '@betty/navigation';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';

type BackButtonProps<T extends ParamListBase> = {
  navigation: NativeStackNavigationProp<T>;
};

function BackButton<T extends ParamListBase>({
  navigation,
}: BackButtonProps<T>) {
  return (
    <PressableIcon
      gradient="accentBackground"
      padding="space-100"
      name="arrowBack"
      iconWidth="space-600"
      iconHeight="space-600"
      onPress={navigation.goBack}
    />
  );
}

export default BackButton;
